import {CreateInstance} from './config'
const ConnUsersAPI = CreateInstance('conn-users')
export default ConnUsersAPI
